export const viewPort = {
  width: 1200,
  height: 800,
};
